import { EntityDetailsData, BreachDetailsData } from "../models/breach-details-model";
import { IBreachDataService } from "../shared/services/breach-data-service-interface";
import { Injectable } from "@angular/core";
import * as moment from "moment";
import "rxjs/add/operator/toPromise";
import { FormatDurationPipe } from "../pipes/format-duration.pipe";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class BreachDetailsDataService implements IBreachDataService {
    private formatDurationPipe: FormatDurationPipe;
    
    constructor(private http: HttpClient) {
        this.formatDurationPipe = new FormatDurationPipe();
    }

    public getBreachData(params: string[]): Promise<EntityDetailsData> {
        return this.http.get(`/data/breaches/venues/${params[0]}`)
        .toPromise()
        .then((res: any) => {
            const server: any = res;
            const result = this.ConvertServerToClient(server);
            return result;
        })
        .then((entityDetails: EntityDetailsData) => {
            return this.addBreachDetailsToEntityDetails(params, entityDetails);
        });
    }

    public ConvertServerToClient(serverData: any): EntityDetailsData {
        const server = serverData;
        const result = new EntityDetailsData();
        result.venue = server.name;
        result.venueLiquorLicenceNumber = server.licenceNumber;
        result.venueType = server.venueType;
        result.licenceStartDate = server.licenceStartDate ? moment(server.licenceStartDate) : undefined;
        result.licenseeName = server.licenseeName;
        result.telephone = server.telephone;
        result.licenceStatus = server.licenceStatus;
        result.email = server.email;
        result.address = server.address;
        result.timeZone = server.timeZone;
        return result;
    }

    private addBreachDetailsToEntityDetails(params: string[], entityDetails: EntityDetailsData): Promise<EntityDetailsData> {
        return this.http.get(`/data/breachDetail/${params[0]}/${params[1]}/${params[2]}/`)
        .toPromise()
        .then((res: any) => {
            const server: any [] = res.data;
            const breachDetailsArray = this.convertToBreachDetailsArray(server);
            entityDetails.tableData.allRows = breachDetailsArray;
            entityDetails.tableData.copyAllRows();
            return entityDetails;
        });
    }

    private convertToBreachDetailsArray(serverData: Array<any>): Array<BreachDetailsData> {
        const result = new Array<BreachDetailsData>();
        serverData.forEach(server => {
            const z = new BreachDetailsData();
            z.gmid = server.gmid;
            z.serial = server.serial;
            z.dateDetectedStart = moment(server.dateDetectedStart);
            z.dateDetectedEnd = moment(server.dateDetectedEnd);
            // convert duration hours to transformed value i.e. days, minutes, hours
            // originally created as a pipe for the html, but unneccesary now (kept as pipe)
            z.durationHours = this.formatDurationPipe.transform(server.durationHours);
            z.turnOver = server.turnOver;
            z.gamesPlayed = server.gamesPlayed;
            z.dateNonTradingPrevStart = server.dateNonTradingPrevStart;
            z.dateNonTradingPrevEnd = server.dateNonTradingPrevEnd;
            z.dateNonTradingNextStart = server.dateNonTradingNextStart;
            z.dateNonTradingNextEnd = server.dateNonTradingNextEnd;
            z.dateShutdownStart = server.dateShutdownStart;
            z.dateShutdownEnd = server.dateShutdownEnd;
            result.push(z);
        })
        return result;
    }
}



// WEBPACK FOOTER //
// ./client/app/services/breach-details-data-service.ts